import React from 'react';
import Reactor from 'data/reactor';
import { Route, Routes } from 'react-router';
import ga from 'utils/react-google-analytics';

import AppWrapper from 'components/app-wrapper';
import StudentSelection from 'components/student-selection';
import StudentProfile from 'components/student-profile';

import DataLoader from 'data/loader';
import Analytics from 'utils/analytics';
import Actions from 'data/actions';
import Getters from 'data/getters';
import SessionStorageUtils from './data/session-storage/utils';
import { convertMeasurementScaleToSPv2Subject, SINGLE_STUDENT_PATH } from 'resources/common-values';
import Cookies from 'js-cookie';
import { worker } from '../mocks/browser.js';
import withRouter from '../app/components/ComponentWithRouterProp';

if (process.env.START_MOCKS === 'true') {
    // intentionally use require for dynamic loading
    const { worker } = require('../mocks/browser');
    worker.start();
}

class ReportingUiRouter extends React.Component {
    componentDidMount() {
        if (__GA__) {
            //Handle bookmarking deep links to pages -- need to figure out their path
            let path = Analytics.sanitizePath(window.location.hash.replace(/#/, ''));
            ga('create', __GA__, 'auto');
            Analytics.recordPageView(path);
        }
    }

    render() {
        return (
            <Routes>
                <Route path={SINGLE_STUDENT_PATH} element={<AppWrapper />} key="single-student-base-route">
                    <Route index element={<StudentProfile />} key="student-profile-route" />
                </Route>
                <Route path="/" element={<AppWrapper />} key="base-route">
                    <Route index element={<StudentSelection />} key="index-route" />
                    <Route path="students" element={<StudentSelection />} key="students-route" />
                    <Route path="family-report" element={<StudentSelection />} key="family-report-route" />
                    <Route path="students/profile" element={<StudentProfile />} key="student-profile-route" />
                </Route>
            </Routes>
        );
    }
}

export default withRouter(ReportingUiRouter);
